export enum LabelListEnum {
  GMP = "GMP",
  OVERHEAD_RATIO = "OVERHEAD RATIO",
  STO_TO_REVENUE_RATIO = "SOH TO REVENUE RATIO",
  EMPLOYEE_COST_RATIO = "EMPLOYEE COST TO REVENUE RATIO",
  EMPLOYEE_COST_TO_EXPENSE_RATIO = "EMPLOYEE COST TO EXPENSE RATIO",
}